import { render } from "./PaymentTypeMultiselect.vue?vue&type=template&id=724922b3"
import script from "./PaymentTypeMultiselect.vue?vue&type=script&lang=js"
export * from "./PaymentTypeMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__